import { PublicClubPostsSortingEnum } from '@alliance/clubs/domain'

const sorting: Partial<Record<PublicClubPostsSortingEnum, string>> = {
  [PublicClubPostsSortingEnum.ByDateDesc]: 'Нові',
  [PublicClubPostsSortingEnum.ByWeek]: 'За тиждень',
  [PublicClubPostsSortingEnum.ByMonth]: 'За місяць',
  [PublicClubPostsSortingEnum.ByYear]: 'За рік'
}

export default {
  foundItems: 'Знайдено {amount} {amount, plural, one{матеріал} few{матеріала} other{матеріалів}}',
  empty: {
    title: 'Вибачте, за вашим запитом нічого не знайдено',
    description: 'Можна спробувати ще раз із іншими ключовими словами, або почитати щось на',
    homepage: 'головній'
  },
  sorting: {
    mostPopular: 'Найпопулярніші',
    ...sorting
  }
}
